<template lang='pug'>
  .mr-site-search(:class="{open: searchOpen}" :aria-hidden="!searchOpen")
    .close-search(@click="closeSearch")
    .fixed-width-tweak-upper
      .search-wrap
        form.search-form(@submit.prevent="performSearch")
          label.search-text.xs-hide.sm-hide.md-hide.lg-f-large.max-at-tweak(@click="performSearch" for="site-search")
            span.icon-magnify
            span.xs-f-xmedium.md-f-large.lg-f-xmedium.max-at-tweak Search anytime by typing and hit enter
          .input-wrap
            input#site-search.search-input(ref="searchInput" v-model="searchTerm" placeholder="search" required :tabindex="searchOpen ? 0 : -1")

          button.search-button.bg-purple.lg-hide(type="submit" :tabindex="searchOpen ? 0 : -1")
            span.icon-magnify.color-white
              span.ada-tooltip search

        button.icon-x.btn-reset.clickable.xs-f-xlarge.md-f-xxlarge.lg-f-xlarge.max-at-tweak(@click="closeSearch" :tabindex="searchOpen ? 0 : -1")
          span.ada-tooltip close

</template>

<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    name: 'MrSiteSearch',

    data: function() {
      return {
        searchTerm: '',
        searching: false
      };
    },

    computed: {
      ...mapState('global', [
        'searchOpen'
      ])
    },

    watch: {
      'searchOpen': function(newValue) {
        if (newValue) {
          this.$refs.searchInput.focus();
        }
      }
    },

    methods: {
      ...mapMutations('global', [
        'setSearchOpen'
      ]),

      performSearch() {
        this.setSearchOpen(false);
        window.location = '/search/' + encodeURIComponent(this.searchTerm);
      },

      closeSearch() {
        this.setSearchOpen(false);
      }
    }
  };
</script>

<styl lang='stylus' scoped>

</styl>